import { Box, Button } from '@mui/material'

import { LoginFormContainer } from '@workwave-tidal/core/login-ui/LoginFormContainer'
import { TidalThemeProvider } from '@workwave-tidal/core/styles'

import { ValidationSummary } from '@workwave-tidal/core/form'
import { RouteManager } from '@workwave-tidal/core/icons/logos'
import { ResetPasswordForm, type ResetPasswordFormState } from '@workwave-tidal/core/login-ui'

import { useStandardPasswordValidations } from '@/components/form/tidal-form/hooks/useStandardPasswordValidations'
import { AppContainer, AppContent } from '@/components/layout'
import { useQueryParameters } from '@/hooks'

import { useNavigate } from '@/routing'

import { useActions } from './hooks/useActions'
import { useTexts } from './hooks/useTexts'

const boxStyle = { height: 'auto' }
const logoStyle = { marginBottom: 2 }
const backToLoginButtonStyle = { textTransform: 'capitalize', padding: 1 }
const containerStyle = {
  margin: '0 auto',
  height: '100%',
  display: 'flex',
  padding: '0 20px',
  maxWidth: '400px',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
}

function PasswordValidations() {
  const validationSummaryItems = useStandardPasswordValidations<
    'newPassword',
    ResetPasswordFormState
  >('newPassword')

  return (
    <ValidationSummary<ResetPasswordFormState> items={validationSummaryItems} mode="show-errors" />
  )
}

export function ResetPassword() {
  const { resetPassword: token } = useQueryParameters()

  const { onGoToLogin, onResetPassword } = useActions(token)
  const navigate = useNavigate()

  const texts = useTexts()

  if (!token) {
    navigate('/error/invalid-reset-password-token')
  }

  return (
    <AppContainer>
      <AppContent>
        <Box sx={containerStyle}>
          <TidalThemeProvider>
            <LoginFormContainer
              logo={<RouteManager width={340} sx={logoStyle} />}
              title={texts.resetPassword.logo}
              form={
                <ResetPasswordForm
                  sx={boxStyle}
                  texts={texts.resetPassword}
                  testId="login-form"
                  mode="single-password"
                  onSubmit={onResetPassword}
                  customSlot={<PasswordValidations />}
                />
              }
              actions={
                <Box paddingLeft={1} paddingRight={1} width="100%">
                  <Button
                    sx={backToLoginButtonStyle}
                    size="large"
                    color="primary"
                    onClick={onGoToLogin}
                    fullWidth
                    data-testid="back-to-login-button"
                  >
                    {texts.backToLogin}
                  </Button>
                </Box>
              }
            />
          </TidalThemeProvider>
        </Box>
      </AppContent>
    </AppContainer>
  )
}
